<template>
  <div class="newstopic">
    <el-scrollbar class="comments">
      <div class="news_topic">
        <div
          class="news_topic_title"
          :title="newsTopicObj.content"
        >{{newsTopicObj.content}}</div>
        <div class="news_topic_title">
          <span>采访时间</span>
          <span>{{newsTopicObj.interview_time}}</span>
          <span style="margin-left:36px;">上稿时间</span>
          <span>{{newsTopicObj.draft_time}}</span>
        </div>
      </div>

      <div class="topic_other_info">
        <span class="iconfont icon-zhuangtai"></span>
        <span class="title">选题状态</span>
        <div class="topic_other_content">
          <span>{{newsTopicObj.status}}</span>
        </div>
      </div>

      <div class="topic_other_info">
        <span class="iconfont icon-laiyuan"></span>
        <span class="title">选题来源</span>
        <div class="topic_other_content">
          <span>{{newsTopicObj.source}}</span>
        </div>
      </div>

      <div class="topic_other_info">
        <span class="iconfont icon-mianban"></span>
        <span class="title">所属面板</span>
        <div class="topic_other_content">
          <span
            v-for="(item,index) in newsTopicObj.list_panel"
            :key="index"
          >{{item}}</span>
        </div>
      </div>

      <div class="news_topic_content">
        <div class="news_topic_person">
          <div class="news_topic_person_left">
            <span class="iconfont icon-renwu"></span>
            <span class="person_title">创建人</span>
          </div>
          <div class="news_topic_person_right">
            <div class="news_topic_person_each">
              <div class="news_topic_person_avator">
                <img
                  :src="newsTopicObj.reporter_headimg"
                  alt=""
                  v-if='newsTopicObj && newsTopicObj.reporter_headimg'
                >
                <img
                  src="../../../static/img/avatar.png"
                  alt=""
                  v-if='!newsTopicObj.reporter_headimg'
                >
              </div>
              <div class="news_topic_person_name">{{newsTopicObj.reporter}}</div>
            </div>
          </div>
        </div>

        <div class="news_topic_person">
          <div class="news_topic_person_left">
            <span class="iconfont icon-renwu"></span>
            <span class="person_title">负责人</span>
          </div>
          <div class="news_topic_person_right">
            <div
              class="news_topic_person_each"
              v-if='newsTopicObj.responsibleList && newsTopicObj.responsibleList.length>0'
              v-for='(item,index) in newsTopicObj.responsibleList'
              :key="index"
            >
              <div class="news_topic_person_avator">
                <img
                  :src="item.headimg"
                  alt=""
                  v-if='item.headimg'
                >
                <img
                  src="../../../static/img/avatar.png"
                  alt=""
                  v-if='!item.headimg'
                >

              </div>
              <div class="news_topic_person_name">{{item.username}}</div>
            </div>
          </div>
        </div>

        <div class="news_topic_person">
          <div class="news_topic_person_left">
            <span class="iconfont icon-renwu"></span>
            <span class="person_title">执行人</span>
          </div>
          <div class="news_topic_person_right">
            <div
              class="news_topic_person_each"
              v-for='item in newsTopicObj.executiveList'
              v-if='newsTopicObj.executiveList && newsTopicObj.executiveList.length>0'
            >
              <div class="news_topic_person_avator">
                <img
                  :src="item.headimg"
                  alt=""
                  v-if='item.headimg'
                >
                <img
                  src="../../../static/img/avatar.png"
                  alt=""
                  v-if='!item.headimg'
                >

              </div>
              <div class="news_topic_person_name">{{item.username}}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="topic_other_info"
        style="border-top:0;border-bottom:1px solid #ccc;"
      >
        <span class="iconfont icon-leixing"></span>
        <span class="title">报道类型</span>
        <div class="topic_other_content">
          <span
            v-for="(item,index) in newsTopicObj.list_column_type"
            :key="index"
          >{{item}}</span>
        </div>
      </div>

      <div
        class="topic_other_info"
        style="border-top:0;border-bottom:1px solid #ccc;"
      >
        <span class="iconfont icon-lanmu"></span>
        <span class="title">拟发栏目</span>
        <div class="topic_other_content">
          <span
            v-for="(item,index) in newsTopicObj.list_news_column"
            :key="index"
          >{{item}}</span>
        </div>
      </div>

      <div
        class="topic_other_info"
        style="border-top:0;border-bottom:1px solid #ccc;"
      >
        <span class="iconfont icon-shebei"></span>
        <span class="title">携带设备</span>
        <div class="topic_other_content">
          <span
            v-for="(item,index) in newsTopicObj.list_device"
            :key="index"
          >{{item}}</span>
        </div>
      </div>

      <div class="interview">
        <span class="iconfont icon-ditu"></span>
        <span class="interview_title">采访地址</span>
        <input
          type="text"
          readonly
          v-model="newsTopicObj.interview_address"
          :title="newsTopicObj.interview_address"
        >
      </div>
      <div class="interview">
        <span
          class="iconfont icon-beizhu"
          style="font-size:18px;margin-left:4px;"
        ></span>
        <span class="interview_title">选题备注</span>
        <input
          type="text"
          readonly
          v-model="newsTopicObj.remarks"
          :title="newsTopicObj.remarks"
        >
      </div>

      <div
        class="topic_other_info"
        style="border-top:0;border-bottom:1px solid #ccc;"
      >
        <span class="iconfont icon-guanjianci"></span>
        <span class="title">关键词</span>
        <div class="topic_other_content">
          <span
            v-for="(item,index) in newsTopicObj.list_keyword"
            :key="index"
          >{{item}}</span>
        </div>
      </div>

      <div
        class="interview"
        style="border:0;"
      >
        <span
          class="iconfont icon-gaojianshu"
          style="font-size:24px;"
        ></span>
        <span class="interview_title">稿件</span>
        <span
          class="interview_title"
          v-if='newsTopicObj && newsTopicObj.manuscript_count'
        >（{{newsTopicObj.manuscript_count-1}}）</span>
      </div>
      <div
        class="news_topic_artilcelist"
        v-if='newsTopicObj.listArticleInfo && newsTopicObj.listArticleInfo.length>0'
      >
        <div
          class="news_topic_article_each"
          v-for='item in newsTopicObj.listArticleInfo'
        >
          <span
            class="iconfont icon-gou"
            v-if="item.article.audit_status=='yes'"
            style="font-size:14px;"
          ></span>
          <span
            class="iconfont icon-cha"
            v-if="item.article.audit_status=='no'"
            style="font-size:14px;"
          ></span>
          <span
            class="iconfont icon-shenhezhong"
            v-if="item.article.audit_status=='doing'"
            style="color:#F5A623;font-size:14px;"
          ></span>
          <span class="iconfont icon-wodegaojian"></span>
          <div
            class="news_topic_artilce_title"
            :title="item.article.title"
            v-if="item.article"
          >{{item.article.title}}</div>
          <div
            class="news_topic_artilce_title news_topic_reponame"
            :title="item.path"
          >{{item.path}}</div>
        </div>
      </div>
      <div
        class="interview"
        style="border:0;"
      >
        <span
          class="iconfont icon-sucaiku"
          style="font-size:14px;margin-left:4px;"
        ></span>
        <span
          class="interview_title"
          style="margin-left:2px;"
        >素材</span>
      </div>

      <div class="news_topic_material">
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='all'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("all")'
        >
          <span>全部</span>
          <span v-if='newsTopicObj && newsTopicObj.material_count'>({{newsTopicObj.material_count}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='picture'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("picture")'
        >
          <span>图片</span>
          <span v-if="newsTopicObj.materialInfo && newsTopicObj.materialInfo.listPicture">({{newsTopicObj.materialInfo.listPicture.length}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='video'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("video")'
        >
          <span>视频</span>
          <span v-if="newsTopicObj.materialInfo && newsTopicObj.materialInfo.listVideo">({{newsTopicObj.materialInfo.listVideo.length}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='audio'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("audio")'
        >
          <span>音频</span>
          <span v-if="newsTopicObj.materialInfo && newsTopicObj.materialInfo.listAudio">({{newsTopicObj.materialInfo.listAudio.length}})</span>
        </div>
        <div
          class="news_topic_material_title"
          :class="[currentMaterialType=='attachment'?'news_topic_titleActive':'']"
          @click.stop='getEachTypeMaterialData("attachment")'
        >
          <span>附件</span>
          <span v-if="newsTopicObj.materialInfo && newsTopicObj.materialInfo.listFile">({{newsTopicObj.materialInfo.listFile.length}})</span>
        </div>
      </div>
      <div class="news_topic_material_content">
        <div
          class="news_topic_material_each"
          v-for='item in currentMaterial'
        >
          <div class="news_topic_material_each_opacity">
            <span
              v-if='item.type === "picture" || item.type === "video" || item.type === "audio"'
              @click.stop='previewFile(item)'
            >预览</span>
            <span
              style="margin-left:4px;"
              v-if='isCanInsert && (item.type === "picture" || item.type === "video" || item.type === "audio")'
            >|</span>
            <span
              style="margin-left:4px;"
              v-if='isCanInsert && (item.type === "picture" || item.type === "video" || item.type === "audio")'
              @click.stop='insertImgToEditor(item)'
            >插入</span>
            <span
              style="margin-left:4px;"
              v-if='item.type === "picture" || item.type === "video"'
            >|</span>

            <span
              v-if='item.type !== "audio"'
              style="margin-left:4px;"
              @click.stop='downLoadData(item)'
            >下载</span>
          </div>

          <div class="news_topic_material_img">
            <img
              :src="item.url"
              alt=""
              v-if="item.type=='picture'"
            >
            <img
              src="../../../static/img/newsvideo.png"
              alt=""
              v-if='item.type=="video"'
            >
            <img
              src="../../../static/img/newsaudio.png"
              alt=""
              v-if='item.type=="audio"'
            >
            <img
              src="../../../static/img/newsfujian.png"
              alt=""
              v-if='item.type=="file"'
            >
          </div>
          <div
            class="news_topic_material_name"
            :title="item.title"
          >
            {{item.title}}
          </div>
        </div>
      </div>

    </el-scrollbar>
  </div>
</template>

<script>
import { getUrlCode } from '../../../utils/index.js'
import * as api from '../../../api'
import { download } from '../../../helpers/exportFile'
export default {
  name: 'newstopic',
  data () {
    return {
      currentMaterialType: 'all',
      currentMaterial: []
    }
  },
  props: {
    isCanInsert: {
      type: Boolean,
      required: true
    }
  },
  created () {

  },
  components: {

  },
  computed: {
    newsTopicObj () {
      return this.$store.state.logs.newsTopicInfoData
    }
  },
  mounted () {


  },
  destroyed () {

  },
  methods: {
    getEachTypeMaterialData (type) {
      this.currentMaterialType = type
      if (this.newsTopicObj) {
        switch (type) {
          case 'all':
            this.currentMaterial = this.newsTopicObj.listMaterial
            break;
          case 'picture':
            this.currentMaterial = this.newsTopicObj.materialInfo.listPicture
            break;
          case 'video':
            this.currentMaterial = this.newsTopicObj.materialInfo.listVideo
            break;
          case 'audio':
            this.currentMaterial = this.newsTopicObj.materialInfo.listAudio
            break;
          case 'attachment':
            this.currentMaterial = this.newsTopicObj.materialInfo.listFile
            break;
          default:
            break;
        }
      }

    },

    insertImgToEditor (item) {
      this.$parent.$parent.insertContentToEditor(item)
    },
    previewFile (item) {
      if (item.type === 'video') {
        this.$root.eventHub.$emit('previewVideoModel', item)
      } else if (item.type === 'audio') {
        this.$root.eventHub.$emit('previewAudioModel', item)
      }
      else if (item.type === 'picture') {
        this.$root.eventHub.$emit('previewPictureModel', item)
      }
    },
    downLoadData (item) {
      var file = ''
      if (item.type === "video") {
        file = 'video'
      } else {
        file = 'file'
      }
      var option = {
        ...this.$store.getters.baseOption,
        "params": {
          "url": item.url,     // 必须字段： 视频素材 ID
          'type': file,
          'title': item.title
        }
      }
      api._post(_TEMPORARYURL_ + 'oss_service/anonymous/downloadFile', option).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            download(res.data)
          }

        }

      }).catch((error) => {
        console.error(error)
      })
    }

  },
  watch: {
    newsTopicObj () {
      if (this.newsTopicObj) {
        this.currentMaterial = this.newsTopicObj.listMaterial
      } else {
        this.currentMaterial = []
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/newstopic.styl'

.topic_other_info
  display flex
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  padding-left 10px
  width 100%
  border-top 1px solid #ccc

  span
    color #606266
    font-size 14px

  .iconfont
    margin-right 6px
    color #b5b8d9
    font-size 16px

  .topic_other_content
    flex 1

    span
      margin-left 10px
</style>
